import { writable } from 'svelte/store';
import collect from 'collect.js';
// Models
import Bet from '@/Models/Bet.js';
// Stores
import { mergeModelDataInCollectionStore, mergeOrAddModelDataInCollectionStore } from '@/Stores/StoreHelpers.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	// eslint-disable-next-line no-unused-vars
	let _store;

	const { subscribe, set, update } = writable(collect());

	subscribe((current) => (_store = current));

	let meta;

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getFilterMeta() {
			if (meta && meta.pagination) {
				// eslint-disable-next-line no-unused-vars
				const { pagination, ...filterMeta } = meta;
				return filterMeta.available_filters;
			}
			return meta;
		},

		getTickerBets(pagination = null, filter, sort, dateColumn = 'created_at') {
			let bet = new Bet();

			if (filter) {
				if (
					('from_date' in filter && filter['from_date'] !== '') ||
					('to_date' in filter && filter['to_date'] !== '')
				) {
					if ('to_date' in filter && !('from_date' in filter)) {
						bet = bet.where(dateColumn, {
							to: encodeURIComponent(filter.to_date),
							from: ''
						});
					} else if ('from_date' in filter && !('to_date' in filter)) {
						bet = bet.where(dateColumn, {
							to: '',
							from: encodeURIComponent(filter.from_date)
						});
					} else {
						bet = bet.where(dateColumn, {
							to: encodeURIComponent(filter.to_date),
							from: encodeURIComponent(filter.from_date)
						});
					}
				}
				for (const [key, value] of Object.entries(filter)) {
					if (value.toString().length && key !== 'from_date' && key !== 'to_date') {
						bet = bet.where(key, value.toString());
					}
				}
			}

			if (sort) {
				bet.orderBy(sort.col, sort.direction);
			}

			let results = pagination ? bet.paginate(pagination.size, pagination.number) : bet.get();

			return results
				.then((result) => {
					meta = result.meta;
					set(result.data);
				})
				.catch((e) => {
					console.error(e);
				});
		},

		addBetFromData(data) {
			const bet = new Bet();
			let result = bet.respond(data);
			if (result) {
				mergeOrAddModelDataInCollectionStore(result, this);
			}
		},

		mergeBetData(data) {
			mergeModelDataInCollectionStore(data, this);
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
